import { IELTFormData } from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'
import { eltEventBus } from 'legacy/lut/components/widgets/public/partner360/ELT/eventBus/eltEventBus'
import { KpiTable } from 'legacy/lut/components/widgets/public/partner360/ELT/ui/kpiTable/KpiTable'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { FlexDirectionBreak } from 'core-components/sitebuilder/models/flexGrid/FlexDirectionBreak'
import { selectUser } from 'core-components/sitebuilder/store/selectors/selectUser'
import { MeasureController } from 'core/analytics'
import { ActualsValueTypes } from 'partner360/models/actualValueTypes'

import { EltPlanning } from '../../../planning/components/eltPlanning/EltPlanning'
import { getFormedEltTranslation } from '../../helpers/getFormedEltTranslation'
import { Title } from '../styledComponents/title/Title'

import { ShortTermInitiatives } from './components/shortTermInitiatives/ShortTermInitiatives'

import styles from './ScoreCard.module.scss'

interface IScoreCardProps {
  uid?: string
  formData: IELTFormData
  fYear: number
  netNdpValue: ActualsValueTypes
}

export const ScoreCard = ({ uid, formData, fYear, netNdpValue }: IScoreCardProps) => {
  const user = useSelector(selectUser)
  const metrics = useMemo(() => new MeasureController('ELTPlanning', { user }), [user])

  return (
    <>
      <KpiTable data={formData.PLC} plcParams={formData.PLCParams} />

      <div className={styles.root}>
        <Title
          text={getFormedEltTranslation('fin-sob-plan-table-title')}
          variant={'withBackground'}
        />
        <EltPlanning
          uid={uid}
          fYear={fYear}
          netNdp={netNdpValue}
          widgetParams={{}}
          metrics={metrics}
          eventBus={eltEventBus}
        />
      </div>

      <ShortTermInitiatives uid={uid} netNdp={netNdpValue} />
    </>
  )
}
